var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPricingIconInstashop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2874_9410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7266 9.44016L9.94665 14.2202C9.82282 14.3441 9.67576 14.4425 9.5139 14.5096C9.35204 14.5767 9.17853 14.6112 9.00331 14.6112C8.82809 14.6112 8.65459 14.5767 8.49273 14.5096C8.33086 14.4425 8.18381 14.3441 8.05998 14.2202L2.33331 8.50016V1.8335H8.99998L14.7266 7.56016C14.975 7.80998 15.1144 8.14791 15.1144 8.50016C15.1144 8.85241 14.975 9.19035 14.7266 9.44016Z",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66663 5.16675H5.67329",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2874_9410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingIconInstashop);
export default __webpack_public_path__ + "static/media/pricing-icon-instashop.09f3d2d3e1d22319f9c1adea2383f002.svg";
export { ForwardRef as ReactComponent };